<script setup lang="ts">
import { ReactiveFile } from "~/classes/file/ReactiveFile"

const { state: myself } = useSelf()
const { sidebarRootsId } = useGlobals()

const home = computed({
  get: () => myself.value.home!,
  set: (value) => {
    myself.value.home = value
  },
})
const archive = computed({
  get: () => myself.value.archive!,
  set: (value) => {
    myself.value.archive = value
  },
})

if (!home.value || !archive.value)
  throw new Error("Myself must have home and archive folders")

const reactiveHome = new ReactiveFile({
  file: home,
  location: "sidebar",
})
const reactiveArchive = new ReactiveFile({
  file: archive,
  location: "sidebar",
})
</script>

<template>
  <sidebar-section>
    <template #default>
      <div :id="sidebarRootsId" class="roots">
        <sidebar-entry-file
          fractional-index="fixme"
          :file="reactiveHome"
        />
        <sidebar-entry-file
          fractional-index="fixme"
          :file="reactiveArchive"
        />
        <sidebar-entry-agent />
      </div>
    </template>
  </sidebar-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.roots
  @apply flex flex-col gap-[#{$sidebar-gap-content-section}]
</style>
